// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide {
  position: relative;
  left: 20%;
  width: 60%;
  height: 40vh;
}

.show {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  animation: fade 0s ease-in-out;
}

.show > div {
  width: 100%;
  height: 100%;
}

img {
  width: 100%;
  height: 100%;
}

/* @-webkit-keyframes trans {
  from {
    left: 100%;
  }
  to {
    left: 0%;
  }
}

@keyframes trans {
  from {
    left: 100%;
  }
  to {
    left: 0%;
  }
} */

@keyframes fade {
  from {
    opacity: 0.1;
  }
  to {
    opacity: 1;
  }
}

.not-show {
  display: none;
}

.prev {
  position: absolute;
  top: 50%;
  left: 1px;
  transform: translateY(-50%);
}

.next {
  position: absolute;
  top: 50%;
  right: 1px;
  transform: translateY(-50%);
}

button {
  border: 0;
  background-color: Transparent;
  font-size: 20px;
}

.page {
  text-align: center;
}
.dot {
  cursor: pointer;
  height: 5px;
  width: 20px;
  margin: 0 2px;
  background-color: #ddd;
  display: inline-flex;
  transition: background-color 0.6s ease;
}

button:hover,
.dot:hover,
.active {
  background-color: #717171;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/Carousel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;;EAGE,yBAAyB;EACzB,UAAU;AACZ","sourcesContent":[".slide {\n  position: relative;\n  left: 20%;\n  width: 60%;\n  height: 40vh;\n}\n\n.show {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  animation: fade 0s ease-in-out;\n}\n\n.show > div {\n  width: 100%;\n  height: 100%;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n/* @-webkit-keyframes trans {\n  from {\n    left: 100%;\n  }\n  to {\n    left: 0%;\n  }\n}\n\n@keyframes trans {\n  from {\n    left: 100%;\n  }\n  to {\n    left: 0%;\n  }\n} */\n\n@keyframes fade {\n  from {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.not-show {\n  display: none;\n}\n\n.prev {\n  position: absolute;\n  top: 50%;\n  left: 1px;\n  transform: translateY(-50%);\n}\n\n.next {\n  position: absolute;\n  top: 50%;\n  right: 1px;\n  transform: translateY(-50%);\n}\n\nbutton {\n  border: 0;\n  background-color: Transparent;\n  font-size: 20px;\n}\n\n.page {\n  text-align: center;\n}\n.dot {\n  cursor: pointer;\n  height: 5px;\n  width: 20px;\n  margin: 0 2px;\n  background-color: #ddd;\n  display: inline-flex;\n  transition: background-color 0.6s ease;\n}\n\nbutton:hover,\n.dot:hover,\n.active {\n  background-color: #717171;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
